<template>
  <div class="md-layout">
    <md-card class="md-layout-item md-size-50 md-small-size-100 margin-top-10">
      <md-card-header>
        <p class="md-title">Statistics</p>
      </md-card-header>

      <md-card-content>
        <div v-if="enterpriseStats.totalDocuments">
          <div class="md-layout">
            <div class="md-layout-item">
              <p class="md-subheading">Total documents created</p>
              <span class="md-display-2" v-text="enterpriseStats.totalDocuments"></span>
            </div>
            <div class="md-layout-item">
              <p class="md-subheading">Documents created in the last 12 months</p>
              <span
                class="md-display-2"
                v-text="enterpriseStats.totalDocumentsCreatedLast12Months"
              ></span>
            </div>
            <div class="md-layout-item">
              <p class="md-subheading">Documents created this year</p>
              <span
                class="md-display-2"
                v-text="enterpriseStats.totalDocumentsCreatedThisYear"
              ></span>
            </div>
          </div>

          <div class="md-layout mt-1">
            <div class="md-layout-item">
              <p class="md-subheading">Total documents sent</p>
              <span class="md-display-2" v-text="enterpriseStats.totalDocumentsSent"></span>
            </div>
            <div class="md-layout-item">
              <p class="md-subheading">Documents sent in the last 12 months</p>
              <span
                class="md-display-2"
                v-text="enterpriseStats.totalDocumentsSentLast12Months"
              ></span>
            </div>
            <div class="md-layout-item">
              <p class="md-subheading">Documents sent this year</p>
              <span class="md-display-2" v-text="enterpriseStats.totalDocumentsSentThisYear"></span>
            </div>
          </div>

          <div class="md-layout mt-1">
            <div class="md-layout-item">
              <p class="md-subheading">
                Documents sent in the current period
                <md-icon class="md-size-xs">info</md-icon>
                <md-tooltip>{{ $t('tooltips.enterprise.documentsSentInPeriod') }}</md-tooltip>
              </p>
              <span class="md-display-2" v-text="enterpriseStats.documentsSentInPeriod"></span>
            </div>
            <div class="md-layout-item">
              <p class="md-subheading">
                Documents deficit for period
                <md-icon class="md-size-xs">info</md-icon>
                <md-tooltip>{{ $t('tooltips.enterprise.documentDeficit') }}</md-tooltip>
              </p>
              <span
                class="md-display-2"
                v-text="enterpriseStats.documentQuotaDelta"
                v-if="enterpriseStats.documentQuotaDelta < 0"
              ></span>
              <span
                class="md-display-2"
                v-text="0"
                v-if="enterpriseStats.documentQuotaDelta >= 0"
              ></span>
            </div>
            <div class="md-layout-item">
              <p class="md-subheading">
                Document surplus for period
                <md-icon class="md-size-xs">info</md-icon>
                <md-tooltip>{{ $t('tooltips.enterprise.documentSurplus') }}</md-tooltip>
              </p>
              <span
                class="md-display-2"
                v-text="enterpriseStats.documentQuotaDelta"
                v-if="enterpriseStats.documentQuotaDelta > 0"
              ></span>
              <span
                class="md-display-2"
                v-text="0"
                v-if="enterpriseStats.documentQuotaDelta <= 0"
              ></span>
            </div>
          </div>

          <ps-bar-chart
            class="inline-stats"
            :chart-data="documentsSentPerMonth.render()"
            :options="documentChartOptions">
          </ps-bar-chart>

          <div class="vertical-spacing half"></div>

          <div class="md-layout">
            <div class="md-layout-item">
              <p class="md-subheading">Status for documents created in the last 12 months</p>
            </div>
          </div>

          <div class="vertical-spacing half"></div>

          <ps-pie-chart
            class="inline-stats"
            :chart-data="documentsByStatus"
            :options="documentChartOptions">
          </ps-pie-chart>
        </div>
        <div v-if="!enterpriseStats.totalDocuments">
          <p class="md-subheading">Business did not send any documents.</p>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>
<script type="ts">
import PsBarChart from '@/components/charts/psBarChart';
import PsPieChart from '@/components/charts/psPieChart';
import EnterpriseStats from '@/datatypes/enterprise-stats';
import camelcaseKeysDeep from 'camelcase-keys-deep';
import EnterpriseService from '@/services/enterprise/EnterpriseService';
import DatapointCollection from '@/datatypes/DatapointCollection';

export default {
  name: 'enterprise-chart-display',
  components: {
    PsBarChart, PsPieChart,
  },
  props: ['enterprise'],
  data: () => ({
    documentChartOptions: { responsive: true, height: 250, maintainAspectRatio: false },
    settableKinds: [
      { id: 0, name: 'Free forever' },
      { id: 1, name: 'API' },
      { id: 2, name: 'Entrepreneur' },
      { id: 3, name: 'Enterprise' },
      { id: 6, name: 'Trial' },
      { id: 7, name: 'Business' },
      { id: 8, name: 'Business pro' },
    ],
    enterpriseStats: new EnterpriseStats({}),
    enterpriseService: new EnterpriseService(),
    documentsSentPerMonth: new DatapointCollection({}),
    documentsByStatus: new DatapointCollection({}),
  }),
  mounted() {
    this.fetchEnterpriseStats();
  },
  methods: {
    fetchEnterpriseStats() {
      this.enterpriseService.getEnterpriseStats(this.$route.params.id).then((response) => {
        this.enterpriseStats = new EnterpriseStats(camelcaseKeysDeep(response.data));
        this.documentsSentPerMonth = new DatapointCollection({
          labels: this.enterpriseStats.documentsSentLast12Months.labels,
          datasets: [
            {
              label: 'Documents sent',
              backgroundColor: '#f49848',
              data: this.enterpriseStats.documentsSentLast12Months.data,
            },
          ],
        });

        this.documentsByStatus = new DatapointCollection({
          labels: this.enterpriseStats.documentsByStatus.labels,
          datasets: [
            {
              label: 'Documents created',
              backgroundColor: this.enterpriseStats.documentsByStatus.backgroundColor,
              data: this.enterpriseStats.documentsByStatus.data,
            },
          ],
        });
      });
    },
  },
};
</script>
